import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { tap } from "rxjs/operators";
import { ApiVersionService } from "./api-version.service";

export const apiVersionInterceptor: HttpInterceptorFn = (req, next) => {
    const service = inject(ApiVersionService);
    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                service.version = event.headers.get("api-version");
            }
        })
    );
};
